import type { Node } from 'react';
import React from 'react';
import { COLORS } from 'Components/utils/color/colors';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { usePageContext } from 'Context/PageContext';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import type { LineProps } from 'Components/frameworks/line/Line';
import { Line } from 'Components/frameworks/line/Line';
import { NavigationTabs } from 'Components/widgets/navigation-tabs/NavigationTabs';
type Props = {
  config: CMSContent;
  lines: Array<{
    props: {
      id: string;
      isExclusiveCollection: boolean;
      title: string;
      lines: ReadonlyArray<LineProps>;
    };
    name: string;
  }>;
};
export const NavigationTabsLine = ({ lines = [] }: Props) => {
  const { pageId, pageType } = usePageContext();
  const { isDesktop } = useResponsive();
  const track = useTracking();
  const items = lines.map((line) => {
    const { id, isExclusiveCollection, title, lines: tabLines } = line.props;
    return {
      headerId: id,
      color: isExclusiveCollection ? COLORS.ULTRAMARINE : COLORS.LIGHT_SAND,
      header: {
        title,
      },
      content: tabLines.map<Node>((l) => {
        const lineId = l?.id?.toString() ?? '';
        return (
          <Line
            {...l}
            dataTestIdPrefix={`${id}-${lineId === 'media-text-horizontal-0' ? 'intro' : lineId}`}
            key={l.id}
          />
        );
      }),
      onClick: () =>
        track({
          actionGA: 'blockInfos',
          categoryGA: pageType,
          labelGA: id || 'productInfos',
        }),
    };
  });

  if (!items.length) {
    return null;
  }

  return items.length > 1 ? (
    <NavigationTabs
      className="Line relative isolate z-1"
      isDesktop={isDesktop}
      items={items}
      key={pageId}
    />
  ) : (
    items[0].content
  );
};
